import React, { useEffect } from 'react';
import { Panel, PanelSpinner } from '@vkontakte/vkui';
import { useAppContext } from '../AppContext';
import { Panels } from './Consts';
import { ErrorLoadComponent } from './components/ErrorLoadComponent';
import { clearCache as eventsListCacheClear } from './Events/EventsListPanel';
import { getRouteEventInfo, getRouteEventsList } from '../route';

const CURRENT_PANEL = Panels.INVITE_PANEL;

const InvitePanel = (props) => {
  const context = useAppContext();
  const params = context.router.getParams();

  const [error, setError] = React.useState(false);

  const fetch = () => {
    const invite = params.invite || '';
    context.init(true)
      .then(() => {
        setError(null);
        context.httpClient()
          .invite(invite)
            .then((response) => {
              setError(null);
              eventsListCacheClear(context.cache);
              context.router.replace(...getRouteEventInfo(response.data.event_id));
            })
            .catch((e) => setError(e));
      })
      .catch((e) => setError(e));

    context.getBridge().retargeting.openInvite(context.store.currentUserId);
  }

  useEffect(() => {
    fetch();
  }, [])

  if (error) {
    return (<ErrorLoadComponent
      error={error}
      onFetch={() => {
        eventsListCacheClear(context.cache);
        context.router.replace(...getRouteEventsList());
      }}
      buttonLabel={context.lang().getKey(CURRENT_PANEL, 'reload_button_label')}
    />)
  }

  return (<Panel id={CURRENT_PANEL}>
    <PanelSpinner />
  </Panel>);
}

export default InvitePanel;
